import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = { class: "card-title d-flex align-items-center" }
const _hoisted_4 = { class: "fw-bold m-0 text-gray-800" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "timeline" }
const _hoisted_7 = { class: "timeline-item" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-line w-40px\"></div><div class=\"timeline-icon symbol symbol-circle symbol-40px\"><div class=\"symbol-label bg-light\"><span class=\"svg-icon svg-icon-2 svg-icon-gray-500\"><i class=\"fas fa-plus-circle\"></i></span></div></div>", 2)
const _hoisted_10 = { class: "grid timeline-content mt-n1 overflow-hidden" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-3 pt-2" }
const _hoisted_14 = { value: "NOTAS_INTERNAS" }
const _hoisted_15 = { value: "LLAMADA" }
const _hoisted_16 = { value: "EMAIL" }
const _hoisted_17 = { class: "col-sm-3 pt-2" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "my-5 col-sm-12" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "d-flex align-items-end justify-content-end" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = { class: "indicator-progress" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_29 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_30 = { class: "symbol-label bg-light" }
const _hoisted_31 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_32 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_33 = { class: "pe-3 mb-5" }
const _hoisted_34 = { class: "fs-5 fw-semobold mb-2" }
const _hoisted_35 = { class: "overflow-auto" }
const _hoisted_36 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 0,
  class: "text-muted me-2 fs-7"
}
const _hoisted_39 = {
  key: 1,
  class: "text-muted me-2 fs-7"
}
const _hoisted_40 = {
  key: 0,
  class: "overflow-auto pb-5"
}
const _hoisted_41 = {
  key: 0,
  class: "border border-dashed border-gray-300 rounded min-w-700px p-7"
}
const _hoisted_42 = { class: "text-uppercase" }
const _hoisted_43 = { class: "text-danger mx-3 fw-bolder" }
const _hoisted_44 = { class: "text-success fw-bolder" }
const _hoisted_45 = {
  key: 1,
  class: "border border-dashed border-gray-300 rounded min-w-700px p-7"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Se ha ")
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bolder" }, "añadido", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" el archivo ")
const _hoisted_49 = { class: "fw-bolder" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Se ha ")
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "text-warning fw-bolder" }, "modificado", -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" el nombre del archivo ")
const _hoisted_53 = { class: "fw-bolder" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Se ha ")
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bolder" }, "eliminado", -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" el archivo ")
const _hoisted_57 = { class: "fw-bolder" }
const _hoisted_58 = {
  key: 2,
  class: "border border-dashed border-gray-300 rounded min-w-700px p-7"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Se cambia el estado de la solicitud en el Servicio Colectivo ")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" a ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_63 = { key: 1 }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Se cambia el estado de la solicitud en el Servicio General a ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_66 = {
  key: 3,
  class: "border border-dashed border-gray-300 rounded min-w-700px p-7"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Se realiza solicitud en el Servicio Colectivo ")
const _hoisted_69 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Se realiza solicitud de ")
const _hoisted_72 = /*#__PURE__*/_createElementVNode("b", null, "Servicio General", -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_74 = [
  _hoisted_71,
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = {
  key: 4,
  class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7",
  style: {"white-space":"break-spaces"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.historico.titulo")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              (!_ctx.addLog)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-light-primary mb-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLog && _ctx.toggleLog(...args)))
                  }, _toDisplayString(_ctx.$t("formularios.familiaDetalle.historico.nuevoLog")), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.addLog)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tipo) = $event)),
                        class: "form-select form-select-sm"
                      }, [
                        _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("formularios.historico.nuevoLog.nota")), 1),
                        _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("formularios.historico.nuevoLog.llamada")), 1),
                        _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t("formularios.historico.nuevoLog.email")), 1)
                      ], 512), [
                        [_vModelSelect, _ctx.tipo]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.fecha,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fecha) = $event)),
                        type: "date",
                        format: "DD/MM/YYYY",
                        placeholder: _ctx.$t('dialogs.seleccionaFecha')
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_input, {
                        rows: 3,
                        autosize: { minRows: 3 },
                        type: "textarea",
                        placeholder: " ",
                        modelValue: _ctx.contenido,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contenido) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ErrorMessage, { name: "contenido" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      (_ctx.addLog)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-light-primary me-3",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleLog && _ctx.toggleLog(...args)))
                          }, _toDisplayString(_ctx.$t("formularios.familiaDetalle.historico.cancelar")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "submit",
                        ref: "submitButton",
                        disabled: !_ctx.meta.valid,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmitNewLog && _ctx.onSubmitNewLog(...args))),
                        id: "kt_new_log_submit",
                        class: "btn btn-primary"
                      }, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("formularios.historico.nuevoLog.guardar")), 1),
                        _createElementVNode("span", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.$t("indicatorProgress")) + " ", 1),
                          _hoisted_27
                        ])
                      ], 8, _hoisted_24)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosHistorico, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "timeline-item"
          }, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.icons[item?.tipo] + ' fs-3')
                  }, null, 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.textos[item.tipo]), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", {
                      class: "text-muted me-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: _ctx.formatHour(item.fecha)
                    }, _toDisplayString(_ctx.formatLongDate(item.fecha)), 9, _hoisted_37),
                    (item.usuario)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t("formularios.historico.por")) + " " + _toDisplayString(item.usuario.username), 1))
                      : (item.usuarioId && !item.usuario)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.$t("formularios.historico.por")) + " " + _toDisplayString(_ctx.$t("formularios.historico.usuarioEliminado")), 1))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (item.contenido)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    (item.tipo == 'MODIFICACION')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.contenido), (contenido, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t(contenido.field.toUpperCase())) + ":", 1),
                              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.moment(contenido.oldValue).isValid()
                          ? _ctx.moment(contenido.oldValue).locale("es").format("LL")
                          : contenido.oldValue), 1),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.moment(contenido.newValue).isValid()
                          ? _ctx.moment(contenido.newValue).locale("es").format("LL")
                          : contenido.newValue), 1)
                            ]))
                          }), 128))
                        ]))
                      : (item.tipo == 'ADJUNTOS')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.contenido)[
                      'added'
                    ], (added, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _hoisted_46,
                                _hoisted_47,
                                _hoisted_48,
                                _createElementVNode("span", _hoisted_49, _toDisplayString(added.nombre), 1),
                                _createTextVNode(" de " + _toDisplayString(_ctx.$t(added.tipo)), 1)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.contenido)[
                      'modified'
                    ], (modified, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _hoisted_50,
                                _hoisted_51,
                                _hoisted_52,
                                _createElementVNode("span", _hoisted_53, _toDisplayString(modified.nombre), 1),
                                _createTextVNode(" de " + _toDisplayString(_ctx.$t(modified.tipo)), 1)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.contenido)[
                      'deleted'
                    ], (deleted, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _hoisted_54,
                                _hoisted_55,
                                _hoisted_56,
                                _createElementVNode("span", _hoisted_57, _toDisplayString(deleted.nombre), 1),
                                _createTextVNode(" de " + _toDisplayString(_ctx.$t(deleted.tipo)), 1)
                              ]))
                            }), 128))
                          ]))
                        : (item.tipo == 'SOLICITUD_SERVICIO_MODIFICACION')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              (JSON.parse(item.contenido).servicioProgramadoId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _hoisted_60,
                                    _createElementVNode("b", null, _toDisplayString(JSON.parse(item.contenido).servicioProgramadoNombre), 1),
                                    _hoisted_61,
                                    _createElementVNode("b", null, _toDisplayString(JSON.parse(item.contenido).estado), 1),
                                    _hoisted_62
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("b", null, _toDisplayString(JSON.parse(item.contenido).estado), 1),
                                    _hoisted_65
                                  ]))
                            ]))
                          : (item.tipo == 'SOLICITUD_SERVICIO_CREACION')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                (JSON.parse(item.contenido).servicioProgramadoId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      _hoisted_68,
                                      _createElementVNode("b", null, _toDisplayString(JSON.parse(item.contenido).servicioProgramadoNombre), 1),
                                      _hoisted_69
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_74))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(item.contenido), 1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}